import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Analytics", "Goals", "Activity", "ProAnalytics"],
  endpoints: (build) => ({
    // Get comprehensive analytics stats
    getAnalyticsStats: build.query({
      query: (params = {}) => ({
        url: "/analytics/stats",
        method: "GET",
        params,
      }),
      providesTags: ["Analytics"],
      transformResponse: (response) => response.data || response,
    }),

    // Get goals with progress
    getGoals: build.query({
      query: () => ({
        url: "/analytics/goals",
        method: "GET",
      }),
      providesTags: ["Goals"],
      transformResponse: (response) => response.data || response,
    }),

    // Get recent activity feed
    getRecentActivity: build.query({
      query: ({ limit = 20 } = {}) => ({
        url: "/analytics/activity",
        method: "GET",
        params: { limit },
      }),
      providesTags: ["Activity"],
      transformResponse: (response) => response.data || response,
    }),

    // Get Pro plan analytics (Deal Analyzer, Farms, etc.)
    getProAnalytics: build.query({
      query: () => ({
        url: "/analytics/pro",
        method: "GET",
      }),
      providesTags: ["ProAnalytics"],
      transformResponse: (response) => response.data || response,
    }),
  }),
});

export const {
  useGetAnalyticsStatsQuery,
  useGetGoalsQuery,
  useGetRecentActivityQuery,
  useGetProAnalyticsQuery,
} = analyticsApi;
